<template>
  <el-form ref="elFormRef" :label-width="80" :model="formData" :rules="formRules">
    <el-form-item label="处理状态" prop="status">
      <el-select v-model="formData.status" placeholder="请选择">
        <el-option v-for="item in options" :key="item" :label="item.label" :value="item.value" />
      </el-select>
    </el-form-item>
  </el-form>
</template>

<script setup>
  import { ref, reactive, defineExpose, defineEmits, getCurrentInstance } from 'vue'
  import { complaintHandle } from '@/api/jbh/complaint'

  const { proxy } = getCurrentInstance()

  const elFormRef = ref()

  const props = defineProps({
    id: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
  })

  const emit = defineEmits(['success'])

  const formData = reactive({
    id: props.id,
    status: props.status,
  })

  const formRules = {
    status: [
      {
        required: true,
        message: '请选择处理状态',
      },
    ],
  }

  function submit() {
    elFormRef.value.validate((valid) => {
      if (!valid) return
      const params = { ...formData }
      complaintHandle(params).then(() => {
        proxy.$baseMessage(`处理成功！`, 'success', 'vab-hey-message-success')
        emit('success')
      })
    })
  }

  defineExpose({
    submit,
  })
</script>

<style lang="scss" scoped></style>
